import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["suggestions"]
  
  connect() {
    this.cities = []
    this.loadCities()
    
    // Create suggestions container
    this.suggestionsDiv = document.createElement('div')
    this.suggestionsDiv.className = 'city-suggestions absolute z-50 w-full bg-white border-2 border-slate-200 shadow-lg max-h-60 overflow-y-auto hidden'
    this.element.parentElement.style.position = 'relative'
    this.element.parentElement.appendChild(this.suggestionsDiv)
    
    // Bind events
    this.element.addEventListener('input', this.handleInput.bind(this))
    this.element.addEventListener('focus', this.handleFocus.bind(this))
    document.addEventListener('click', this.handleClickOutside.bind(this))
  }
  
  disconnect() {
    if (this.suggestionsDiv) {
      this.suggestionsDiv.remove()
    }
    document.removeEventListener('click', this.handleClickOutside.bind(this))
  }
  
  async loadCities() {
    try {
      const response = await fetch('/cities.json')
      this.cities = await response.json()
    } catch (error) {
      console.error('Error loading cities:', error)
    }
  }
  
  handleInput(e) {
    const value = e.target.value.trim()
    
    if (value.length < 1) {
      this.hideSuggestions()
      return
    }
    
    const filtered = this.cities.filter(city => 
      city.toLowerCase().includes(value.toLowerCase())
    )
    
    this.showSuggestions(filtered, value)
  }
  
  handleFocus(e) {
    if (e.target.value.trim().length > 0) {
      this.handleInput(e)
    }
  }
  
  showSuggestions(cities, searchTerm) {
    if (cities.length === 0) {
      this.hideSuggestions()
      return
    }
    
    this.suggestionsDiv.innerHTML = ''
    
    cities.slice(0, 10).forEach(city => {
      const div = document.createElement('div')
      div.className = 'px-4 py-2 cursor-pointer hover:bg-teal-50 border-b border-slate-100 last:border-b-0'
      
      // Highlight matching text
      const regex = new RegExp(`(${this.escapeRegex(searchTerm)})`, 'gi')
      const highlightedCity = city.replace(regex, '<strong>$1</strong>')
      
      div.innerHTML = highlightedCity
      div.addEventListener('click', () => this.selectCity(city))
      
      this.suggestionsDiv.appendChild(div)
    })
    
    this.suggestionsDiv.classList.remove('hidden')
  }
  
  hideSuggestions() {
    this.suggestionsDiv.classList.add('hidden')
  }
  
  selectCity(city) {
    this.element.value = city
    this.hideSuggestions()
  }
  
  handleClickOutside(e) {
    if (!this.element.contains(e.target) && !this.suggestionsDiv.contains(e.target)) {
      this.hideSuggestions()
    }
  }
  
  escapeRegex(string) {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  }
}
